// src/config/env.ts

/**
 * Baked in at build time by CRA via REACT_APP_ENV=beta in the beta workflow.
 * On production builds this is undefined → isBeta is false.
 */
export const isBeta = process.env.REACT_APP_ENV === 'beta';